import React from "react";
import moment from "moment-timezone";

import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";

import {
    Button,
    Card,
    Checkbox,
    Col,
    Icon,
    Input,
    List,
    message,
    notification,
    Popconfirm,
    Popover,
    Row,
    Select,
    Table,
    Tooltip,
    Upload,
} from "antd";

import {
    _getUser,
    _getPurchaseInvoiceData,
    _postSendCheckStockEmail
} from "../../../../services";

import PurchaseInvoiceButton from "./purchase-invoice-button";
import BulkyTag from '../../tags/bulky';
import ExStockTag from "../../../product-ex-stock/tag";

import { DOC_ORDER_TYPES, getOrderDocumentLink, renderVariantName } from "../../../orders-v2/modal";
import { URL_ENDPOINT, SUPPLIER_URL } from '../../../../index';
import ChangeAssignQuickbooksSeller from "./change-assign-quickbooks-seller-button";

const Option = Select.Option;

class SupplierManagementPanel extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            purchaseInvoicesData: [],


            /**
             * @todo refactor!!!!!
             */
            checkStockProducts: [],
            checkStockSentEmail: [],
            checkStockPopoverVisible: [],
            checkStockEmailSupplierDetails: [],

        };
    }

    async componentDidMount() {

        await this.getAndUpdatePurchaseInvoicesData();

    }

    render() {

        const {
            adminPermissions,
            productOrders,
            supplier,
            supplierIndex,
            supplierDetails
        } = this.props;

        return (
            <Card
                style={{ marginBottom: 24 }}
                bodyStyle={{ padding: "12px !important" }}
            >
                <Row type="flex" align="middle" style={{ padding: "0px 16px 8px 16px" }}>
                    <Col span={8} style={{ fontWeight: 500 }}>
                        <Tooltip title={supplier.supplierId}>
                            {supplierDetails ?
                                <div>
                                    <span>{supplierDetails.companyName}</span>
                                    <span
                                        style={{
                                            marginLeft: 8,
                                            fontWeight: 400,
                                            fontStyle: "italic"
                                        }}
                                    >{supplierDetails.quickbooks.seller.displayName}</span>
                                </div>
                                : "No Supplier"}
                        </Tooltip>
                        {(() => {

                            if (!supplierDetails || !supplierDetails.verification) {
                                return null
                            }

                            const checkIcon = <Icon type="check" style={{ color: "#52c41a" }} />
                            const closeIcon = <Icon type="close" style={{ color: "#f5222d" }} />

                            return (
                                <Row
                                    style={{ fontWeight: 400 }}
                                    type="flex" gutter={12}>
                                    <Col>
                                        Verified Bank {supplierDetails.verification.bankInfo && supplierDetails.verification.bankInfo.approve ? checkIcon : closeIcon}
                                    </Col>
                                    <Col>
                                        Verified Company {supplierDetails.verification.companyProfile && supplierDetails.verification.companyProfile.approve ? checkIcon : closeIcon}
                                    </Col>
                                </Row>
                            )

                        })()}
                    </Col>
                    <Col span={16}>
                        <Row type="flex" align="middle" justify="end" gutter={8}>
                            <Col>
                                {adminPermissions.ezOperations && this.renderManageFulfillmentButton(supplier)}
                            </Col>
                            <Col>
                                {adminPermissions.ezOperations && this.renderCheckStockButton(supplier, supplierIndex)}
                            </Col>

                            {supplierDetails && supplierDetails.quickbooks.seller.displayName && (
                                <Col>
                                    <Row type="flex" gutter={8}>
                                        <Col>

                                            <PurchaseInvoiceButton
                                                user={this.props.user}
                                                cart={this.props.cart}

                                                purchaseInvoicesData={this.state.purchaseInvoicesData}
                                                onUploadPurchaseInvoiceSuccess={this.onUploadPurchaseInvoiceSuccess}

                                                qbExpenseAccounts={this.props.qbExpenseAccounts}
                                                qbTerms={this.props.qbTerms}

                                                supplierIndex={supplierIndex}
                                                supplierId={supplier.supplierId}
                                            />

                                        </Col>
                                        <Col>
                                            {this.renderPaymentSlipButton(supplier.supplierId)}
                                        </Col>
                                    </Row>
                                </Col>
                            )}

                            <Col>
                                {adminPermissions.ezFinance &&
                                    <ChangeAssignQuickbooksSeller
                                        updateSupplierDetails={this.props.getAndSetSuppliersDetails}
                                        cart={this.props.cart}
                                        supplierDetails={this.props.supplierDetails}
                                        supplierId={supplier.supplierId}
                                        assigned={supplierDetails && supplierDetails.quickbooks.seller.displayName} />
                                }
                            </Col>

                        </Row>
                    </Col>
                </Row>

                <Table
                    bodyStyle={{
                        fontSize: 12
                    }}
                    pagination={false}
                    columns={this.getTableColumns()}
                    dataSource={productOrders} />

            </Card>
        );
    }

    renderCheckStockButton = (supplier, index) => {

        const {
            cart,
        } = this.props;

        const {
            checkStockEmailSupplierDetails,
            checkStockPopoverVisible,
            checkStockProducts,
            checkStockSentEmail
        } = this.state;

        const { supplierId, products } = supplier
        return (
            <Popover
                visible={checkStockPopoverVisible[index]}
                placement="left"
                trigger="click"
                content={
                    <Row>
                        {checkStockEmailSupplierDetails[index]
                            ?
                            <Card
                                title="Supplier Details"
                            >
                                <Row type="flex" justify="center" style={{ marginBottom: 8 }}>
                                    <span style={{ width: "100%", textAlign: "left", fontWeight: 500 }}>First Name</span>
                                    <Input
                                        onChange={(e) => this.onChangeSupplierFirstNameForCheckStock(e, index)}
                                        defaultValue={checkStockEmailSupplierDetails[index].details.name}
                                    />
                                </Row>
                                <Row type="flex" justify="center" style={{ marginBottom: 16 }}>
                                    <span style={{ width: "100%", textAlign: "left", fontWeight: 500 }}>Email</span>
                                    <Input
                                        onChange={(e) => this.onChangeSupplierEmailForCheckStock(e, index)}
                                        defaultValue={
                                            checkStockEmailSupplierDetails[index].alternateEmail ?
                                                checkStockEmailSupplierDetails[index].alternateEmail
                                                :
                                                checkStockEmailSupplierDetails[index].local.email
                                        }
                                    />
                                </Row>
                                <Row type="flex" justify="end" style={{ marginBottom: 8 }}>
                                    {
                                        cart.lastContact.sentCheckStock && cart.lastContact.sentCheckStock.filter(_sentCheckStock => _sentCheckStock.supplierId === supplierId).length > 0 ?
                                            <Popconfirm
                                                title={<span>Email sending check stock already sent.<br />Send again?</span>}
                                                onConfirm={() => this.sendCheckStockEmail(supplierId, index)}
                                            >
                                                <Button
                                                    type="danger"
                                                    disabled={checkStockProducts.length < 1 || checkStockSentEmail[index]}
                                                >Send</Button>
                                            </Popconfirm>
                                            :
                                            <Button
                                                type="primary"
                                                disabled={checkStockProducts.length < 1 || checkStockSentEmail[index]}
                                                onClick={() => this.sendCheckStockEmail(supplierId, index)}
                                            >
                                                Send
						</Button>
                                    }
                                </Row>
                            </Card>
                            : null}
                        <div style={{
                            padding: 12,
                            maxHeight: 200,
                            overflow: "auto",
                            marginBottom: 16
                        }}>
                            <List
                                size="small"
                                // bordered
                                dataSource={products}
                                renderItem={(_product, _productIndex) => (
                                    <List.Item>
                                        <Row type="flex" justify="space-between">
                                            <Col style={{ marginRight: 16 }}>
                                                {_product.product.title} {renderVariantName(_product.variants)}
                                            </Col>
                                            <Col>
                                                <Checkbox
                                                    defaultChecked={true}
                                                    onChange={(e) => this.onSelectProductsToCheckStock(e, _product, _productIndex, index)} />
                                            </Col>
                                        </Row>
                                    </List.Item>)}
                            />
                        </div>
                        <Row style={{ marginBottom: 16 }} type="flex" justify="center">
                            <Button
                                onClick={() => this.onClickChangeSupplierDetails(supplierId, index)}
                            >
                                {`${!checkStockEmailSupplierDetails[index] ? 'Show' : 'Hide'} Supplier Details`}
                            </Button>
                        </Row>
                    </Row>
                }
            >
                <Button
                    onClick={() => this.onClickCheckStockButton(products, index)}
                >Check stock</Button>
            </Popover>
        );
    }

    renderManageFulfillmentButton = (confirmCheckoutBySupplier) => {

        if (!confirmCheckoutBySupplier || confirmCheckoutBySupplier.supplierId === "noSupplier") {
            return null;
        }

        const { cart } = this.props;

        return (
            <Button target={`${cart._id}/${confirmCheckoutBySupplier.supplierId}`} href={`${SUPPLIER_URL}/order/${cart._id}/${confirmCheckoutBySupplier.supplierId}`}>
                Manage Fulfillment
            </Button>
        )
    }

    renderPaymentSlipButton = (supplierId) => {

        const { permissions } = this.props.user.data

        const { qbDepositToAccounts } = this.props;

        const purchaseInvoiceLink = getOrderDocumentLink({
            cart: this.props.cart,
            docOrderType: DOC_ORDER_TYPES.PURCHASE_INVOICE,
            supplierId
        })

        if (!purchaseInvoiceLink) {
            return (
                permissions.ezFinance &&
                <Button disabled>Payment Slip</Button>
            )
        }

        const paymentSlipLink = getOrderDocumentLink({
            cart: this.props.cart,
            docOrderType: DOC_ORDER_TYPES.PAYMENT_SLIP,
            supplierId
        })

        if (paymentSlipLink) {
            return (
                <div>
                    <a
                        target="_blank"
                        href={paymentSlipLink}>
                        <Button
                            className="fulfilled-button">
                            Payment Slip
						</Button>
                    </a>
                </div>
            )
        } else {
            return (
                permissions.ezFinance &&
                <Popover
                    title="Upload Payment Slip"
                    trigger="click"
                    content={
                        <Row>
                            <Row type="flex" justify="start">
                                Bank/Credit account
							</Row>
                            <Row
                                style={{ marginBottom: 16 }}
                                type="flex" justify="center">
                                <Select
                                    value={this.state.paymentSlipActiveDepositToId}
                                    placeholder="Deposit to"
                                    onChange={(val) => this.setState({ paymentSlipActiveDepositToId: val })}
                                    style={{ width: 150 }}>
                                    {Object.keys(qbDepositToAccounts).map(_key =>
                                        <Option value={qbDepositToAccounts[_key].Id}>
                                            {qbDepositToAccounts[_key].Name}
                                        </Option>
                                    )}
                                </Select>
                            </Row>
                            <Row type="flex" justify="center">
                                <Upload
                                    data={{
                                        accountId: this.state.paymentSlipActiveDepositToId
                                    }}
                                    withCredentials
                                    action={`${URL_ENDPOINT}/api/admin/order-docs/upload-payment-slip/${this.props.cart._id}/${supplierId}/${this.props.user.data.details.name}`}
                                    onChange={(info) => this.onUploadPaymentSlipChangeState(info)}
                                >
                                    <Row type="flex" justify="center">
                                        <Button
                                            type="primary">Upload</Button>
                                    </Row>
                                </Upload>
                            </Row>
                        </Row>
                    }
                >
                    <Button>
                        Payment Slip
					</Button>
                </Popover>
            )
        }
    }

    getAndUpdatePurchaseInvoicesData = async () => {
        
        const { cart } = this.props;

        let purchaseInvoiceRes = await _getPurchaseInvoiceData({
            cartId: cart._id,
            supplierIds: cart.confirmCheckout.map(_confirmCheckout => _confirmCheckout.supplierId)
        });

        const purchaseInvoicesData = purchaseInvoiceRes.data;

        this.setState({
            purchaseInvoicesData
        });

    }

    getProductOrderStatus = ( productOrderId ) => {

        if (!this.props.orderStatus || this.props.orderStatus.length == 0) {
            return false;
        }

        const productOrderStatus = this.props.orderStatus.productOrderStatus.filter( 
            _pos => _pos.productOrderId == productOrderId 
        )[0];

        return productOrderStatus;

    }

    getQtyFulfilled = ( productOrder ) => {

        const productOrderStatus = this.getProductOrderStatus( productOrder._id );

        if( productOrderStatus.status !== "AWAIT_PAYMENT" && productOrderStatus.status !== "COMPLETED"){
            return 0;
        }

        return productOrderStatus.quantity;

    }

    getQtyOrderedFinal = ( productOrder ) => {

        const productOrderStatus = this.getProductOrderStatus( productOrder._id );
        return productOrderStatus.quantity;

    }

    getQtyOrderedInitial = ( productOrder ) => {

        let quantity = productOrder.quantity;
        return quantity;

    }

    getQtyRejected = ( creditNotes, productOrderId ) => {

        let qtyRejected = 0;

        for (let i = 0; i < creditNotes.length; i++) {
                        
            const creditNote = creditNotes[i];

            for (let j = 0; j < creditNote.lines.length; j++) {

                const creditNoteLines = creditNote.lines[j];

                if( creditNoteLines.productOrderId == productOrderId ){
                    qtyRejected = qtyRejected + creditNoteLines.quantity
                }
                
            }

        }

        return qtyRejected;

    }

    getTableColumns = () => {

        return [
            {
                title: 'Title',
                key: "title",
                render: (text, productOrder, index) => {

                    const productOrderStatus = this.getProductOrderStatus(productOrder._id)
                    const isBulky = productOrderStatus.isBulky
                    const isCustom = productOrder.product.customProduct
                    const exStockProduct = productOrder.product.exStock
                    const productSellerUrl = `${SUPPLIER_URL}/products/${productOrder.product._id}`
                    const productTitle = isCustom ? 
                        productOrder.product.title : 
                        <a href={productSellerUrl}>{productOrder.product.title}</a>

                    // name && name.length > 0? `${name.substring(0,0)}..`: name
                    return productOrder.orderStatus.cantFulfill ?
                        <span
                            style={{
                                color: "#f5222d",
                                textDecoration: "line-through"
                            }}
                        >
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                                {productTitle}
                                { exStockProduct && <ExStockTag/>}
                                {isBulky && <BulkyTag data={productOrder.product.shipping}/>}
                            </span>
                        </span>
                        :
                        <span>
                            {productTitle}
                            { exStockProduct && <ExStockTag/>}
                            {isBulky && <BulkyTag data={productOrder.product.shipping}/>}
                        </span>
                }
            },


            {
                title: 'Var',
                key: "variants",
                render: (text, productOrder, index) => {
                    return (
                        renderVariantName(productOrder.variants)
                    )
                }
            },

            {
                title: 'Qty Ordered',
                key: "qtyOrdered",
                
                render: (text, productOrder, index) => {

                    let qtyOrderedInitial = this.getQtyOrderedInitial( productOrder );
                    let qtyOrderedFinal = this.getQtyOrderedFinal( productOrder );
                    let qtyRejected = this.getQtyRejected( this.props.creditNotes, productOrder._id );

                    if( qtyOrderedInitial !== ( qtyOrderedFinal - qtyRejected ) ){
                        return (
                            <div>
                                <span style={{ color: "red", textDecoration: "line-through" }}>
                                    {qtyOrderedInitial}
                                </span>

                                {" --> "}

                                <span>
                                    {qtyOrderedFinal - qtyRejected}
                                </span>
                            </div>
                        )
                    }

                    return qtyOrderedInitial;
                }
            },

            {
                title: "Qty Fulfilled",
                key: "qtyFulfilled",
                render: ( text, productOrder, index ) => {

                    const qtyFulfilled = this.getQtyFulfilled( productOrder );
                    return qtyFulfilled;

                }
            },

            {
                title: "Qty Rejected",
                key: "qtyRejected",
                render: ( text, productOrder, index ) => {

                    const { creditNotes } = this.props;
                    const productOrderId = productOrder._id;
                    
                    let qtyRejected = this.getQtyRejected( creditNotes, productOrderId );
                    return qtyRejected;

                }
            },

            {
                title: 'Unit Price',
                key: "amountUnitPrice",
                render: (text, productOrder, index) => {

                    if (!productOrder.amount.unitPrice) {
                        return null;
                    }

                    return (
                        <span>{productOrder.amount.unitPrice.toFixed(2)}</span>
                    )
                }
            },

            {
                title: 'Price',
                key: "amountPrice",
                render: (text, productOrder, index) => {

                    if (!productOrder.amount.price) {
                        return null;
                    }

                    return (
                        <span>{productOrder.amount.price.toFixed(2)}</span>
                    )
                }
            },

            {
                title: 'Status',
                key: "status",
                render: (text, productOrder, index) => {

                    const productOrderStatus = this.getProductOrderStatus( productOrder._id );

                    if (!productOrderStatus) {
                        return "ERROR"
                    }

                    if (productOrderStatus.status == "AWAIT_ACCEPT_LEAD_TIME" && productOrderStatus.leadTimeCutOffDate) {
                        return (
                            <div>
                                <div>{productOrderStatus.status}</div>
                                <b>{moment(productOrderStatus.leadTimeCutOffDate).tz("Asia/Singapore").format('YYYY-MM-DD')}</b>
                            </div>
                        )
                    }

                    return productOrderStatus.status;
                }
            },
            {
                title: 'Cost / Margin',
                key: "costAndMargin",
                render: (text, productOrder, index) => {

                    let supplierPurchaseInvoice = this.state.purchaseInvoicesData.filter(_dataRow => _dataRow.supplierId == productOrder.product.supplierId);

                    // If none found , return null
                    if (supplierPurchaseInvoice.length <= 0) {
                        return null;
                    }

                    // If found, filter to the right productOrderStatus
                    let supplierPurchaseInvoiceToProductOrderStatus = supplierPurchaseInvoice[0].products.filter(_dataRow => _dataRow.productOrderStatusId == productOrder._id);

                    // If none found , return null
                    if (supplierPurchaseInvoiceToProductOrderStatus.length <= 0) {
                        return null;
                    }

                    // If found, show cost and margin
                    let cost = supplierPurchaseInvoiceToProductOrderStatus[0].cost;
                    let salePrice = productOrder.amount.price;
                    let margin = (((salePrice - cost) / salePrice) * 100).toFixed(0);

                    return `${cost} / ${margin}%`;
                }

            },
            {
                title: 'Logs',
                key: "logs",
                render: (text, productOrder, index) => {

                    if (!this.props.cart.orderStatusLogs || this.props.cart.orderStatusLogs.length == 0) {
                        return null;
                    }

                    const osl = this.props.cart.orderStatusLogs.filter(_osl => _osl.productOrderId == productOrder._id);

                    if (osl.length == 0) {
                        return '-';
                    }

                    osl.sort((a, b) => a.dateCreated < b.dateCreated);

                    return (
                        <a
                            onClick={() => {
                                return notification.open({
                                    message: `${productOrder.product.title}`,
                                    description: (
                                        <div>
                                            {osl.map(_osl => {
                                                return (
                                                    <div>
                                                        <u>{moment(_osl.dateCreated).tz("Asia/Singapore").format("LLLL")}</u>
                                                        <div
                                                            style={{ marginBottom: 12 }}
                                                            dangerouslySetInnerHTML={{ __html: _osl.activityPretty }} />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ),
                                    duration: 0
                                });
                            }}
                        >
                            View {osl.length} logs
                        </a>
                    );
                }
            },

            {
                title: "Batch",
                key: 'changeSupplier',
                render: (text, productOrder, index) => {
                    return (
                        <Row type="flex" justify="center">
                            <Checkbox
                                disabled={productOrder.orderStatus.cantFulfill}
                                checked={this.props.selectedProductIds.includes(productOrder._id)}
                                onChange={(e) => this.props.onSelectProductOrder(e, productOrder._id)} />
                        </Row>
                    )
                }

            }
        ];

    }

    onChangeSupplierEmailForCheckStock = (e, index) => {

        let email = e.target.value

        let checkStockEmailSupplierDetails = this.state.checkStockEmailSupplierDetails

        checkStockEmailSupplierDetails[index].local.email = email

        this.setState({ checkStockEmailSupplierDetails })

    }

    onChangeSupplierFirstNameForCheckStock = (e, index) => {

        let firstName = e.target.value

        let checkStockEmailSupplierDetails = this.state.checkStockEmailSupplierDetails

        checkStockEmailSupplierDetails[index].details.name = firstName

        this.setState({ checkStockEmailSupplierDetails })


    }

    onClickChangeSupplierDetails = (supplierId, index) => {

        let { checkStockEmailSupplierDetails } = this.state

        if (!checkStockEmailSupplierDetails[index]) {

            if (supplierId !== "noSupplier") {

                _getUser(supplierId)
                    .then(res => {

                        checkStockEmailSupplierDetails[index] = res.data
                        this.setState({ checkStockEmailSupplierDetails })

                    })

            } else {
                checkStockEmailSupplierDetails[index] = {
                    local: {
                        email: ""
                    },
                    details: {
                        name: ""
                    }
                }

                this.setState({ checkStockEmailSupplierDetails })

            }
        } else {
            //if already open
            checkStockEmailSupplierDetails[index] = false

            this.setState({ checkStockEmailSupplierDetails })

        }



    }

    onClickCheckStockButton = (products, index) => {

        let {
            checkStockProducts,
            checkStockPopoverVisible,
            checkStockEmailSupplierDetails
        } = this.state

        if (checkStockPopoverVisible[index]) {
            //close popover
            checkStockProducts[index] = false
            checkStockPopoverVisible[index] = false
            // checkStockEmailSupplierDetails[index] = false

        } else {

            let checkStockProductsSingle = products.map(_product => {
                return ({
                    title: _product.product.title,
                    variants: _product.variants,
                    quantity: _product.quantity,
                    updatedQuantity: _product.updatedQuantity || false
                })
            })

            checkStockProducts[index] = checkStockProductsSingle
            checkStockPopoverVisible[index] = true

        }


        this.setState({
            checkStockProducts,
            checkStockPopoverVisible,
            checkStockEmailSupplierDetails
        });

    }

    onSelectProductsToCheckStock = (e, _product, productIndex, supplierIndex) => {

        let { checkStockProducts } = this.state

        if (!e.target.checked) {

            checkStockProducts[supplierIndex][productIndex] = false

        } else {

            let { quantity, updatedQuantity, variants } = _product
            let title = _product.product.title

            checkStockProducts[supplierIndex][productIndex] = {
                title,
                quantity,
                updatedQuantity,
                variants
            }

        }

        this.setState({ checkStockProducts })

    }

    onUploadPaymentSlipChangeState = (info) => {

		if (info.file.status === "done" && info.file.response.success) {

			const { cart, orderDocuments } = info.file.response
            message.success(`Payment Slip uploaded for ${cart.adminControls.offlineReferenceNumber}`);
            this.props.updateOrderModalCart({
                ...cart,
                orderDocuments
            });
		}

		if (info.file.status === "error") {
			message.error(`Error uploading payment slip for ${this.props.cart.adminControls.offlineReferenceNumber}`, 10)
		}
	}

    onUploadPurchaseInvoiceSuccess = ({ cart, orderDocuments }) => {

        this.getAndUpdatePurchaseInvoicesData();
        this.props.updateOrderModalCart({
            ...cart,
            orderDocuments
        });

    }

    sendCheckStockEmail = (supplierId, index) => {

        let {
            checkStockSentEmail,
            checkStockProducts,
            checkStockPopoverVisible,
            checkStockEmailSupplierDetails,
        } = this.state;

        let {
            cart
        } = this.props;

        let products = checkStockProducts[index].filter(_product => _product !== false)

        let firstName = this.state.checkStockEmailSupplierDetails[index].details.name
        let toEmail = this.state.checkStockEmailSupplierDetails[index].local.email

        //for preventing double click
        checkStockSentEmail[index] = true

        this.setState({
            checkStockSentEmail: checkStockSentEmail.map((_email, j) => j !== index ? _email : true)
        });

        _postSendCheckStockEmail({
            cartId: cart._id,
            products,
            supplierId,
            admin: cart.agent,
            firstName,
            toEmail
        })
            .then(res => {
                if (res.data.success) {

                    // checkStockEmailSupplierDetails[index] = false
                    checkStockPopoverVisible[index] = false;
                    checkStockProducts[index] = false;
                    checkStockSentEmail[index] = false;

                    //reset for supplier
                    this.setState({
                        checkStockProducts,
                        checkStockSentEmail,
                        checkStockPopoverVisible,
                        checkStockEmailSupplierDetails,
                    });

                    this.props.updateOrderModalCart(res.data.cart);

                    message.success(`Emails sent for ${cart.adminControls.offlineReferenceNumber}`)

                } else {
                    message.error(`Emails errored for ${cart.adminControls.offlineReferenceNumber}`, 10)
                }
            })
    }
}

export default connect(
    state => ({
        adminUserIdEmailMap: state.admins.userIdEmailMap,
        user: state.user
    })
)(withRouter(SupplierManagementPanel));


// WEBPACK FOOTER //
// ./src/components/orders-v3/modal/supplier-management-panel/index.js